import type { AssetType } from '@cartwhl/common/api/getAssets';
import Text from '@cartwhl/ui/base/Text';
import CheckmarkIcon from '@cartwhl/ui/icons/CheckmarkIcon';
import CrossIcon from '@cartwhl/ui/icons/CrossIcon';
import Button from '@cartwhl/ui/input/Button';

import AssetLibraryThumbnail from '../../AssetLibrary/components/AssetLibraryThumbnail';

export interface MascotReferenceUploadRowProps {
  index: number;
  thumbnailUrl: string;
  assetType: AssetType;
  onRemove: () => void;
}

export default function MascotReferenceUploadRow({
  index,
  thumbnailUrl,
  assetType,
  onRemove,
}: MascotReferenceUploadRowProps) {
  return (
    <div className="group/item flex items-center gap-1 px-3 py-2">
      <Text
        variant="studio/body/medium/sm"
        className="text-secondary w-5 shrink-0"
      >
        {index + 1}.
      </Text>

      <div className="bg-tertiary relative h-10 w-[72px] shrink-0 overflow-hidden rounded-md">
        {thumbnailUrl ? (
          <AssetLibraryThumbnail
            assetType={assetType}
            thumbnailURL={thumbnailUrl}
            className="h-full w-full"
          />
        ) : (
          <div className="bg-tertiary h-full w-full" />
        )}
      </div>

      <div className="relative flex h-[30px] w-[30px] shrink-0 items-center justify-center">
        <CheckmarkIcon className="text-green h-5 w-5 transition-opacity duration-200 group-hover/item:opacity-0" />
        <Button
          onClick={(event) => {
            event.stopPropagation();
            onRemove();
          }}
          aria-label="Remove"
          variant="tertiary"
          size="sm"
          className="text-secondary pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-200 group-hover/item:pointer-events-auto group-hover/item:opacity-100"
          icon={<CrossIcon />}
        />
      </div>
    </div>
  );
}
